<template>
  <router-view />
</template>

<script>
export default {
  name: 'Draft'
}
</script>

<style scoped>

</style>
